// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import ElementUI, { FormItem } from "element-ui";
import { Message } from "element-ui";
import "element-ui/lib/theme-chalk/index.css"; // 默认主题
import "../static/css/theme-eleui/index.css";
import { pcaa } from "./components/common/area-data-vue";
import "area-linkage-vue/dist/index.css";
import AreaLinkageVue from "area-linkage-vue";
import VueCookies from "vue-cookies";
import VueDirectiveImagePreviewer from "vue-directive-image-previewer";
import "vue-directive-image-previewer/dist/assets/style.css";
import dragScroll from "./components/common/dragScroll"; //拖动惯性
import SlideVerify from 'vue-monoplasty-slide-verify';
import preventReClick from './components/common/prevent' //防止多次点击

Vue.use(SlideVerify);

Vue.use(dragScroll);
Vue.use(VueDirectiveImagePreviewer, {
  zIndex: 9999, //层级显示
  previewSize: 15 //15倍图
});
Vue.use(preventReClick)
// import { $cookies } from "vue/types/umd";
Vue.prototype.$pcaa = pcaa;
Vue.use(AreaLinkageVue);
Vue.use(VueCookies);
Vue.config.productionTip = false;
Vue.use(ElementUI);
/* eslint-disable no-new */
// router.beforeEach((to, from, next) => {
//   //获取用户登录成功后储存的登录标志
//   let getFlag = $cookies.get("peopleId");
//   //如果有peopleId，即用户已登录
//   if (getFlag) {
//     //如果已登录，还想想进入登录注册界面，则定向回首页
//     if (to.meta.isLogin) {
//       next({
//         path: "/index"
//       });
//     } else {
//       next();
//     }
//     //如果登录标志不存在，即未登录
//   } else {
//     //用户想进入需要登录的页面，则定向回登录界面
//     if (to.meta.needLogin) {
//       Message.warning("请先登录");
//       next({
//         path: "/login"
//       });
//     } else {
//       next();
//     }
//   }
// });
// router.afterEach((to, from, next) => {

//   if (from.name != '商品详情' && to.name == '商品分类') {
//     let isRefresh = sessionStorage.getItem('isRefresh');
//     if (isRefresh == '0') {
//       sessionStorage.setItem('isRefresh', null);
//       window.location.reload()
//     } else {
//       sessionStorage.setItem('isRefresh', 0);
//     }
//   } else if (to.name != '商品详情' && from.name == '商品分类') {
//     sessionStorage.setItem('isRefresh', 0);
//   }


// })
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js